export default "__VITE_ASSET__D_iAKb6S__"